module.exports = __webpack_public_path__ + "media/public/fonts/QanelasMedium/QanelasMedium-345d21964f36901ed852e0b6760f33f1.svg";